import { observer } from 'mobx-react';
import { useTranslation } from 'react-i18next';

import { useStores } from '../../../stores/useStores';
import { formatValueWithK } from '../../../utils/helpers';

import styles from './ChallengesWidget.module.scss';

export const ChallengesWidget = observer(() => {
  const { challengesStore } = useStores();
  const { activeMissionProgress } = challengesStore;
  const { t } = useTranslation();

  const onClickHandler = () => {
    void challengesStore.startChallengesDialog();
  };

  return (
    <div className="home-widget">
      <div className={styles.challengesWidget} onClick={onClickHandler}>
        <div className={styles.circle} />
        <img
          alt="Challenges Widget"
          className={styles.widgetImage}
          src="/images/challenges/challenges-widget-main.png"
        />
        {activeMissionProgress && (
          <div className={styles.progressBar}>
            {activeMissionProgress.current > 0 && (
              <div
                className={styles.progressFill}
                style={{ width: `${(activeMissionProgress.current / activeMissionProgress.target) * 100}%` }}
              />
            )}
            <span className={styles.progressText}>
              {formatValueWithK(activeMissionProgress.current, t)}/{formatValueWithK(activeMissionProgress.target, t)}
            </span>
          </div>
        )}
      </div>
    </div>
  );
});
